import { render, staticRenderFns } from "./UnvalidLink.vue?vue&type=template&id=bdb8f01c"
import script from "./UnvalidLink.vue?vue&type=script&lang=js"
export * from "./UnvalidLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports